import i from "../../../translations/i"
import { QuillEditor } from "../../../components/QuillEditor"
import { Col } from "antd";
import React from "react";

export const RenderTextType = ({ value, onChange }: any) => {

  return (
    <Col span={24}>
      <label className="formLabel">{i.t('def:text')}</label>

      <QuillEditor
        value={value}
        onChange={(e: any) => onChange(e)}
      />
    </Col>
  )
}